import $ from "jquery";
import gsap from "gsap/dist/gsap.min";
import ScrollTrigger from "gsap/dist/ScrollTrigger.min";
import {ScrollToPlugin} from "gsap/dist/ScrollToPlugin.min";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
window.$ = window.jQuery = $;

$(function () {
    $(".split-title").each(function () {
        const $el = $(this);
        if (!$el.attr("data-original-html")) {
            $el.attr("data-original-html", $el.prop("innerHTML"));
        }
    });

    prepareSplitTitles();
});


function prepareSplitTitles() {
    $(".split-title").each(function () {
        const $el = $(this);

        if (!$el.attr("data-original-html")) {
            $el.attr("data-original-html", $el.prop("innerHTML"));
        }

        const html = $el.attr("data-original-html");
        const wrapper = $("<span>").css("display", "inline");

        function wrapNode(node, container) {
            if (node.nodeType === 3) {
                const text = node.textContent;
                const regex = /(\S+|\s+|[,.!?]+(?=\s|$))/g;
                for (const match of text.matchAll(regex)) {
                    const word = match[0];

                    const $wordWrapper = $("<span>").addClass("word");

                    for (const char of word) {
                        const span = $("<span>")
                            .addClass("char")
                            .text(char === " " ? "\u00A0" : char);
                        $wordWrapper.append(span);
                    }

                    container.append($wordWrapper);
                }

            } else if (node.nodeName === "BR") {
                container.append(document.createElement("br"));
            } else if (node.nodeType === 1) {
                const tag = node.nodeName.toLowerCase();

                if (tag === "strong") {
                    const $strong = $("<strong>");
                    const childAttrs = node.attributes;

                    for (let i = 0; i < childAttrs.length; i++) {
                        $strong.attr(childAttrs[i].name, childAttrs[i].value);
                    }

                    [...node.childNodes].forEach((child) => {
                        wrapNode(child, $strong);
                    });

                    container.append($strong);
                    return;
                }

                const $childWrapper = $("<" + tag + ">");
                const childAttrs = node.attributes;

                for (let i = 0; i < childAttrs.length; i++) {
                    $childWrapper.attr(childAttrs[i].name, childAttrs[i].value);
                }

                [...node.childNodes].forEach((child) => {
                    wrapNode(child, $childWrapper);
                });

                container.append($childWrapper);
            }
        }

        const parsed = $.parseHTML(html);
        parsed.forEach((node) => wrapNode(node, wrapper));
        $el.empty().append(wrapper);
    });
}

function animateSplitTitles() {
    $(".split-title").each(function () {
        const $el = $(this);
        const $chars = $el.find("span.char");
        const $subtitle = $el.closest(".hero-content").find(".subtitle");
        const $strong = $el.find("strong");
        const $fadeinExtras = $el.closest(".hero-content, .default-section").find(".fadeinslow");

        const totalDuration = $chars.length * 0.015 + 0.1;

        function playAnimation() {
            gsap.fromTo($chars.toArray(),
                {y: 40, opacity: 0},
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.4,
                    ease: "power3.out",
                    stagger: 0.015
                });

            if ($subtitle.length) {
                gsap.fromTo($subtitle.get(),
                    {opacity: 0, y: 20},
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        delay: totalDuration,
                        ease: "power2.out"
                    });
            }

            if ($fadeinExtras.length) {
                gsap.fromTo($fadeinExtras.toArray(),
                    {opacity: 0, y: 20},
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        delay: totalDuration + 0.2,
                        ease: "power2.out",
                        stagger: 0.2
                    });
            }

            setTimeout(() => {
                $strong.addClass("animated");
            }, totalDuration * 1000);
        }

        const isMobile = window.innerWidth < 992;

        if (!isMobile) {
            // Op desktop: wel checken of al zichtbaar bij load
            const rect = $el[0].getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

            if (isVisible) {
                playAnimation();
                return;
            }
        }

        // Voor desktop én mobile → ScrollTrigger
        ScrollTrigger.create({
            trigger: $el[0],
            start: "top 85%",
            once: true,
            onEnter: playAnimation
        });
    });
}

function removeBrOnSmallScreens() {
    if (window.innerWidth < 992) {
        document.querySelectorAll(".split-title br").forEach((br) => {
            br.style.display = "none";
        });
    } else {
        document.querySelectorAll(".split-title br").forEach((br) => {
            br.style.display = "inline";
        });
    }
}

$(function () {
    prepareSplitTitles();
});

window.addEventListener("load", () => {
    const box = document.querySelector(".preloader-box");
    const preloader = document.getElementById("preloader");
    const fullWidth = window.innerWidth;
    const boxWidth = fullWidth - 30;

    const tl = gsap.timeline({
        defaults: {ease: "power3.inOut"},
        onComplete: () => {
            gsap.to(preloader, {
                duration: 0.6,
                opacity: 0,
                pointerEvents: "none",
                onComplete: () => {
                    preloader.remove();
                    startVideosAfterPreloader();
                    animateSplitTitles();
                    animateServices();
                    animateAbsImage();
                    animateGallery();
                    animateFallbackFadeinslow();
                    removeBrOnSmallScreens();
                    setupMobileParallax();
                }
            });
        }
    });

    tl.to(box, {duration: 1, y: window.innerHeight - 280});
    tl.to(box, {duration: 0.8, width: boxWidth + "px"}, "-=0.4");
    tl.to(box, {
        duration: 1.1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: 0,
        width: "100%",
        scaleY: window.innerHeight / 250,
        height: "100vh"
    }, "-=0.2");
});

let resizeTimeout;
window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        if (window.innerWidth < 992) return; // ⛔ skip alles op mobiel

        ScrollTrigger.getAll().forEach((t) => t.kill());

        $(".split-title").each(function () {
            const $el = $(this);
            const original = $el.attr("data-original-html");
            if (original) {
                $el.html(original);
                $el.removeAttr("data-animated");
            }
        });

        prepareSplitTitles();
        animateSplitTitles();
        removeBrOnSmallScreens();
        setupMobileParallax();

    }, 300);
});

function animateServices() {
    gsap.fromTo(
        ".service-column",
        {
            opacity: 0,
            y: 50,
            scale: 0.95
        },
        {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.9,
            ease: "power3.out",
            stagger: {
                amount: 0.6,
                from: "start"
            },
            scrollTrigger: {
                trigger: ".services",
                start: "top 80%",
                once: true,
                toggleActions: "play none none reverse"
            }
        }
    );
}

function animateAbsImage() {
    gsap.fromTo(".abs-image img",
        {
            scale: 0.8,
            opacity: 0
        },
        {
            scale: 1,
            opacity: 1,
            duration: 1.5,
            ease: "power3.out",
            scrollTrigger: {
                trigger: ".default-section.pb-0",
                start: "top 80%",
                toggleActions: "play none none reverse"
            }
        }
    );
}

function animateGallery() {
    var scale = document.querySelectorAll(".gallery-item");
    var image = document.querySelectorAll(".gallery-item img");
    scale.forEach((item) => {
        gsap.to(item, {
            scale: 1,
            duration: 1,
            ease: "power1.out",
            scrollTrigger: {
                trigger: item,
                start: 'top bottom',
                end: "bottom top",
                toggleActions: 'play reverse play reverse'
            }
        });

    });
    image.forEach((image) => {
        gsap.set(image, {
            scale: 1.3,
        });
        gsap.to(image, {
            scale: 1,
            duration: 1,
            scrollTrigger: {
                trigger: image,
                start: 'top bottom',
                end: "bottom top",
                toggleActions: 'play reverse play reverse'
            }
        });
    })
}


function animateFallbackFadeinslow() {
    gsap.utils.toArray(".fadeinslow").forEach((el) => {
        if (el.dataset.animated === "true") return;

        gsap.fromTo(el,
            {
                opacity: 0,
                y: 20
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                    toggleActions: "play none none none"
                }
            }
        );
    });
}

function setupMobileParallax() {
    if (window.innerWidth < 992) {
        document.querySelectorAll(".hero-content").forEach((el) => {
            el.classList.add("parallax-fallback");

            gsap.to(".parallax-fallback", {
                backgroundPosition: "center -20%",
                ease: "none",
                scrollTrigger: {
                    trigger: ".parallax-fallback",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                }
            });
        });
    }
}


function getExitDirection(e, $el) {
    const w = $el.outerWidth();
    const h = $el.outerHeight();
    const offset = $el.offset();
    const x = (e.pageX - offset.left - w / 2) * (w > h ? h / w : 1);
    const y = (e.pageY - offset.top - h / 2) * (h > w ? w / h : 1);
    const angle = Math.atan2(y, x);
    const direction = Math.round((angle / (Math.PI / 2) + 5)) % 4;

    return ['top', 'right', 'bottom', 'left'][direction];
}


$(function () {
    $('.art-button').on('mouseenter', function (e) {
        const $btn = $(this);
        const offset = $btn.offset();
        const x = e.pageX - offset.left;
        const y = e.pageY - offset.top;

        $btn[0].style.setProperty('--circle-x', `${x}px`);
        $btn[0].style.setProperty('--circle-y', `${y}px`);

        gsap.to($btn[0], {
            duration: 0.2, // Snellere animatie (lager dan 0.6)
            ease: 'power2.out',
            onUpdate: function () {
                const progress = this.progress();
                $btn[0].style.setProperty('--circle-scale', progress * 10);
            },
            onComplete: function () {
                $btn[0].style.setProperty('--circle-scale', 10);
            }
        });
    });

    $('.art-button').on('mouseleave', function (e) {
        const $btn = $(this);
        const offset = $btn.offset();
        const x = e.pageX - offset.left;
        const y = e.pageY - offset.top;

        // Nieuwe positie instellen op basis van exitpunt
        $btn[0].style.setProperty('--circle-x', `${x}px`);
        $btn[0].style.setProperty('--circle-y', `${y}px`);

        // Snellere animatie bij verlaten (lager dan 0.4)
        gsap.to($btn[0], {
            duration: 0.1, // Snellere animatie (lager dan 0.4)
            ease: 'power2.in',
            onUpdate: function () {
                const progress = this.progress();
                $btn[0].style.setProperty('--circle-scale', (1 - progress) * 10);
            },
            onComplete: function () {
                $btn[0].style.setProperty('--circle-scale', 0);
            }
        });
    });
});



$(function () {
    $(".hero-content .subtitle, .clicker").on("click", function (e) {
        e.preventDefault();

        const target = $("#oplossingen");
        if (!target.length) return;

        // Scroll native, zonder fade of scroll-effect via GSAP
        window.scrollTo({
            top: target.offset().top,
            behavior: 'smooth'
        });
    });
});

// Gate: video's niet auto-starten tot na de preloader
function initPreloaderVideoGate() {
    document.querySelectorAll('video[data-autoplay-after-preloader]').forEach(v => {
        // Zorg dat ze niet spontaan starten
        v.autoplay = false;
        try { v.pause(); } catch(e){}
        try { v.currentTime = 0; } catch(e){}
        // Preload alvast zodat starten straks snappy is
        v.preload = v.preload || 'auto';
    });
}

// Start na preloader; robust met autoplay-policy fallback
function startVideosAfterPreloader() {
    const vids = document.querySelectorAll('video[data-autoplay-after-preloader]');
    vids.forEach(v => {
        // Voor mobiel/desktop autoplay policies
        if (!v.muted) v.muted = true;
        const p = v.play();
        if (p && typeof p.then === 'function') {
            p.catch(() => {
                // Als autoplay geblokkeerd wordt: start bij eerste user-interactie
                const resume = () => { v.play().catch(()=>{}); window.removeEventListener('pointerdown', resume, {once:true}); };
                window.addEventListener('pointerdown', resume, {once:true});
            });
        }
    });
}